import { motion } from "framer-motion";

const biasClass = (b) => {
  if (b === "LONG") return "border-positive text-positive";
  if (b === "SHORT") return "border-magenta text-magenta";
  return "border-border text-text-secondary";
};

const outcomeClass = (o) => {
  if (String(o).startsWith("+")) return "text-positive";
  if (String(o).startsWith("-")) return "text-magenta";
  if (o === "OPEN") return "text-foreground";
  return "text-text-secondary";
};

export const DecisionLog = ({ rows = [] }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.35 }}
      className="panel lg:col-span-7 flex flex-col min-h-[280px] max-h-[480px]"
      data-testid="decision-log-panel"
    >
      <div className="panel-header shrink-0">
        <h3 className="font-display text-sm font-bold uppercase tracking-tight">
          Decision Log
        </h3>
        <span className="label-micro">{rows.length} entries · decision_log</span>
      </div>

      {rows.length === 0 ? (
        <div className="panel-scroll-body">
          <p className="p-4 text-sm text-text-secondary font-mono">No decision log rows.</p>
        </div>
      ) : (
        <div className="panel-scroll-body">
          <table className="w-full text-[11px] font-mono" data-testid="decision-log-table">
            <thead>
              <tr className="text-left text-text-secondary border-b border-border sticky top-0 bg-surface z-10">
                <Th>Time</Th>
                <Th>Emiten</Th>
                <Th>Decision</Th>
                <Th>Agent</Th>
                <Th align="right">Size IDR</Th>
                <Th align="right">Outcome</Th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr
                  key={r.id}
                  data-testid={`decision-row-${r.id}`}
                  className="border-b border-border/60 hover:bg-surface-muted"
                  title={r.reason}
                >
                  <Td className="num text-text-secondary">{r.time}</Td>
                  <Td>{r.pair}</Td>
                  <Td>
                    <span
                      className={`px-1.5 py-0.5 border text-[10px] uppercase ${biasClass(r.bias)}`}
                      style={{ borderRadius: 2 }}
                    >
                      {r.decision || r.bias}
                    </span>
                  </Td>
                  <Td className="text-text-secondary truncate max-w-[120px]">{r.agent}</Td>
                  <Td align="right" className="num">
                    {r.entry ? r.entry.toLocaleString("id-ID") : "—"}
                  </Td>
                  <Td align="right" className={`num ${outcomeClass(r.outcome)}`}>
                    {r.outcome}
                  </Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </motion.div>
  );
};

const Th = ({ children, align = "left" }) => (
  <th
    className={`px-3 py-2 text-[10px] uppercase tracking-[0.18em] ${
      align === "right" ? "text-right" : "text-left"
    }`}
  >
    {children}
  </th>
);
const Td = ({ children, align = "left", className = "", title }) => (
  <td
    title={title}
    className={`px-3 py-2 ${align === "right" ? "text-right" : "text-left"} ${className}`}
  >
    {children}
  </td>
);

export default DecisionLog;
